import { useNavigate } from "react-router-dom";
import Header from "../../../components/ui/Header";

export default function MockTestInstructions() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="flex justify-between items-center p-4 bg-white shadow-sm">
      
        <div className="flex-1" />
      </div>
      <Header />

      {/* HERO STRIP */}
      <div className="bg-gradient-to-b from-slate-50 to-white border-b">
        <div className="max-w-4xl
 mx-auto px-6 py-6">
   <button
          onClick={() => navigate("/candidate/dashboard")}
          className="bg-gray-600 hover:bg-gray-700 transition text-white px-4 py-2 rounded-lg font-medium"
        >
          ← Back to Dashboard
        </button>
          <h1 className="text-2xl font-semibold text-gray-900 mt-8">
            Mock Test Instructions
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Please read all instructions carefully before starting the test
          </p>

          {/* STEPPER */}
          <div className="mt-6 flex items-center justify-between">
            <Step active label="Instructions" />
            <Line />
            <Step label="Camera Check" />
            <Line />
            <Step label="Test" />
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-4xl
 mx-auto px-6 py-10">
        <div className="bg-white rounded-xl shadow-md border border-slate-200 p-10">


          {/* RULES */}
          <div className="grid md:grid-cols-2 gap-6 text-sm">
            <Rule
              icon="⏱"
              title="Time Bound Test"
              text="The test must be completed within the allotted time."
            />
            <Rule
              icon="📷"
              title="Webcam Monitoring"
              text="Webcam access is mandatory throughout the assessment."
            />
            <Rule
              icon="🖥"
              title="Fullscreen Required"
              text="Exiting fullscreen mode may terminate the test."
            />
            <Rule
              icon="💾"
              title="Auto Save Enabled"
              text="Your responses are saved automatically."
            />
            <Rule
              icon="🚫"
              title="No Answers Shown"
              text="Answers and explanations will not be displayed."
            />
            <Rule
              icon="🔁"
              title="Resume Support"
              text="You may resume the test if disconnected."
            />
          </div>

          {/* WARNING */}
          <div className="mt-8 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-5 py-4 text-sm">
            <span className="text-lg">⚠</span>
            <p className="text-amber-900">
              Once the test starts, the <strong>timer will not pause</strong>.
              Switching tabs or leaving fullscreen may end the test.
            </p>
          </div>

          {/* CTA */}
          <div className="mt-10 pt-6 border-t flex justify-between gap-4">

            <button
              onClick={() => navigate("/candidate/mock-test/camera")}
              className={"bg-blue-600 hover:bg-blue-700 transition text-white px-14 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl"}
            >
              Start Camera Verification →
            </button>
            
  
          </div>
 
          </div>
                     <p className={"mt-3 text-xs text-gray-500 text-center"}>
  You cannot pause the test once started
</p>
        </div>
      </div>
    // </div>
  );
}

/* ---------- Helpers ---------- */

function Step({ label, active }) {
  return (
    <div className="flex flex-col items-center min-w-[90px]">
      <div
        className={`w-9 h-9 flex items-center justify-center rounded-full border-2 text-sm font-semibold
        ${
          active
            ? "border-blue-600 bg-blue-600 text-white shadow-lg scale-105"
            : "border-gray-300 text-gray-400 bg-white"
        }`}
      >
        {active ? "1" : ""}
      </div>
      <span
        className={`mt-2 text-sm ${
          active ? "text-blue-600 font-medium" : "text-gray-400"
        }`}
      >
        {label}
      </span>
    </div>
  );
}

function Line() {
  return <div className="flex-1 h-px bg-gray-300 mx-4" />;
}

function Rule({ icon, title, text }) {
  return (
    <div className="flex gap-4">
      <span className="text-xl">{icon}</span>
      <div>
        <p className="font-medium text-gray-900">{title}</p>
        <p className="text-gray-600 mt-0.5">{text}</p>
      </div>
    </div>
  );
}